export default "__VITE_ASSET__DRKK8a2l__"